import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ContractIterationItemEventItemActivityListPage" */
	'pages/sales/ContractIterationItemEventItemActivity/ContractIterationItemEventItemActivityListPage'));

export default [{ component, exact: true, path: '/sub_partitions/:subPartitionId/contract_iteration_item_event_item_activities' }];